import { createContext, type ReactNode, useContext } from 'react';
import { ThemeProvider } from 'next-themes';
import { useCrowdinTheme } from '@/hooks/use-crowdin-theme';
import type { CrowdinThemeMode } from '@/lib/crowdin-host';

interface CrowdinThemeProviderProps {
    children: ReactNode;
}

const CrowdinThemeModeContext = createContext<CrowdinThemeMode>('light');

export function useCrowdinThemeMode() {
    return useContext(CrowdinThemeModeContext);
}

export function CrowdinThemeProvider({ children }: CrowdinThemeProviderProps) {
    const mode = useCrowdinTheme();

    return (
        <CrowdinThemeModeContext.Provider value={mode}>
            <ThemeProvider attribute="class" forcedTheme={mode} enableSystem={false} disableTransitionOnChange>
                {children}
            </ThemeProvider>
        </CrowdinThemeModeContext.Provider>
    );
}
